class VkVideoFacade {
    constructor() {
        this.selector = '.hh-vk-video-facade';
        this.init();
    }

    init() {
        document.addEventListener('click', this.handleClick.bind(this));
        document.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    handleClick(event) {
        const facade = event.target.closest(this.selector);
        if (!facade || facade.classList.contains('hh-vk-video-facade--loaded')) return;

        event.preventDefault();
        this.loadVideo(facade);
    }

    handleKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const facade = event.target.closest(this.selector);
        if (!facade || facade.classList.contains('hh-vk-video-facade--loaded')) return;

        event.preventDefault();
        this.loadVideo(facade);
    }

    loadVideo(facade) {
        const src = facade.dataset.vkSrc;
        if (!src) return;

        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;

        iframe.addEventListener('load', () => {
            facade.classList.add('hh-vk-video-facade--loaded');
        });

        facade.appendChild(iframe);
    }
}

export default VkVideoFacade;
new VkVideoFacade();
